class HeaderHeightCalc {
    init() {
        const element = document.querySelector('.mn-hdr');
        const updateHeight = () => {
            const hh = element ? element.offsetHeight : 0;

            document.documentElement.style.setProperty('--hh', `${hh}px`);
        };

        updateHeight();

        if (element) {
            this.observer = new ResizeObserver(updateHeight);
            this.observer.observe(element);
        }
    }
}

export default new HeaderHeightCalc();
